import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TransporterService {

  base_url: string;
  constructor(
    public http: HttpClient,
  ) {
    this.base_url = environment.appUrl + "/transporters";
  }

  getTransporter(): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url);
  }

  getAllTransporters(): Observable<any> {

    //change post url next to base_url 
    return this.http.get(this.base_url);
  }

  addTransporter(newTransporter): Observable<any> {

    JSON.stringify(newTransporter);
    //change post url next to base_url 
    return this.http.post(this.base_url, newTransporter);
  }

  updateTransporter(updatedTransporter): Observable<any> {

    JSON.stringify(updatedTransporter);

    //change post url next to base_url 
    return this.http.put(this.base_url, updatedTransporter);
  }

  getTransporterById(id): Observable<any> {

    //change post url next to base_url 
    return this.http.get(this.base_url + '/id/' + id.transporter);
  }

  getTransporterByName(name): Observable<any> {

    //change post url next to base_url 
    return this.http.get(this.base_url + "/" + name);
  }

  getTransporterSummaryReport(from,to): Observable<any>{
    return this.http.get(environment.appUrl + '/reports/transporterstatsbybranch?fromDate=' + from + '&toDate=' + to);
  }
}